/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { AddressDetails__AddressFragmentDoc } from '../addresses/Addresses.generated.js';
import { AttachmentSnapshotFragmentDoc, AttachmentsFragmentDoc, WithItemAttachmentsFragmentDoc } from '../attachments/Attachments.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CrmCompanySelectQueryVariables = Types.Exact<{
  limit: Types.Scalars['Int']['input'];
  filterProjectIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']>>;
  filterTagsAll?: Types.InputMaybe<Array<Types.Scalars['String']['input']>>;
  filterTagsAny?: Types.InputMaybe<Array<Types.Scalars['String']['input']>>;
  filterTagsExclude?: Types.InputMaybe<Array<Types.Scalars['String']['input']>>;
  filterCustomFields?: Types.InputMaybe<Array<Types.CustomFieldFilter>>;
  filterIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']>>;
  filterExcludeIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']>>;
  searchTerm?: Types.InputMaybe<Types.Scalars['String']['input']>;
  filterBusinessPartnerRolesAll?: Types.InputMaybe<Array<Types.Scalars['String']['input']>>;
  filterBusinessPartnerRolesExclude?: Types.InputMaybe<Array<Types.Scalars['String']['input']>>;
}>;


export type CrmCompanySelectQuery = { crmCompanies: { __typename: 'CrmCompanyConnection', totalCount: number, edges: Array<{ __typename: 'CrmCompanyEdge', node: { __typename: 'CrmCompaniesRecord', id: string, number: string, title: string, systemTags: Array<string>, customTags: Array<string>, email: any, abcCategory: Types.CrmOrganisationAbcCategory, businessPartnerStatus?: Types.CrmCompanyBusinessPartnerStatus | null, contactPerson?: { __typename: 'CrmPerson', id: string, fullname: string } | null, billingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, logo: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string }, customFields: Array<{ __typename: 'CustomFieldField', key: string, label: string, value: any }> } }> } | { __typename: 'MissingPermissions' } };

export type CrmCompanySelect_CrmCompaniesRecordFragment = { __typename: 'CrmCompaniesRecord', id: string, number: string, title: string, systemTags: Array<string>, customTags: Array<string>, email: any, abcCategory: Types.CrmOrganisationAbcCategory, businessPartnerStatus?: Types.CrmCompanyBusinessPartnerStatus | null, contactPerson?: { __typename: 'CrmPerson', id: string, fullname: string } | null, billingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, logo: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string }, customFields: Array<{ __typename: 'CustomFieldField', key: string, label: string, value: any }> };

export const CrmCompanySelect_CrmCompaniesRecordFragmentDoc = gql`
    fragment CrmCompanySelect_CrmCompaniesRecord on CrmCompaniesRecord {
  id
  number
  title
  systemTags
  customTags
  email
  abcCategory
  contactPerson {
    id
    fullname
  }
  billingAddress {
    ...AddressDetails__Address
  }
  businessPartnerStatus
  logo {
    ...AttachmentSnapshot
  }
  customFields {
    key
    label
    value
  }
}
    ${AddressDetails__AddressFragmentDoc}
${AttachmentSnapshotFragmentDoc}`;
export const CrmCompanySelectDocument = gql`
    query CrmCompanySelect($limit: Int!, $filterProjectIds: [ID!], $filterTagsAll: [String!], $filterTagsAny: [String!], $filterTagsExclude: [String!], $filterCustomFields: [CustomFieldFilter!], $filterIds: [ID!], $filterExcludeIds: [ID!], $searchTerm: String, $filterBusinessPartnerRolesAll: [String!], $filterBusinessPartnerRolesExclude: [String!]) {
  crmCompanies(
    limit: $limit
    filters: {tagsAll: $filterTagsAll, tagsAny: $filterTagsAny, tagsExclude: $filterTagsExclude, ids: $filterIds, excludeIds: $filterExcludeIds, businessPartnerRolesAll: $filterBusinessPartnerRolesAll, businessPartnerRolesExclude: $filterBusinessPartnerRolesExclude, customFields: $filterCustomFields, projectIds: $filterProjectIds}
    search: $searchTerm
  ) {
    ... on CrmCompanyConnection {
      edges {
        node {
          id
          ...CrmCompanySelect_CrmCompaniesRecord
        }
      }
      totalCount
    }
  }
}
    ${CrmCompanySelect_CrmCompaniesRecordFragmentDoc}`;

/**
 * __useCrmCompanySelectQuery__
 *
 * To run a query within a React component, call `useCrmCompanySelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmCompanySelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmCompanySelectQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      filterProjectIds: // value for 'filterProjectIds'
 *      filterTagsAll: // value for 'filterTagsAll'
 *      filterTagsAny: // value for 'filterTagsAny'
 *      filterTagsExclude: // value for 'filterTagsExclude'
 *      filterCustomFields: // value for 'filterCustomFields'
 *      filterIds: // value for 'filterIds'
 *      filterExcludeIds: // value for 'filterExcludeIds'
 *      searchTerm: // value for 'searchTerm'
 *      filterBusinessPartnerRolesAll: // value for 'filterBusinessPartnerRolesAll'
 *      filterBusinessPartnerRolesExclude: // value for 'filterBusinessPartnerRolesExclude'
 *   },
 * });
 */
export function useCrmCompanySelectQuery(baseOptions: Apollo.QueryHookOptions<CrmCompanySelectQuery, CrmCompanySelectQueryVariables> & ({ variables: CrmCompanySelectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CrmCompanySelectQuery, CrmCompanySelectQueryVariables>(CrmCompanySelectDocument, options);
      }
export function useCrmCompanySelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrmCompanySelectQuery, CrmCompanySelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CrmCompanySelectQuery, CrmCompanySelectQueryVariables>(CrmCompanySelectDocument, options);
        }
export function useCrmCompanySelectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CrmCompanySelectQuery, CrmCompanySelectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CrmCompanySelectQuery, CrmCompanySelectQueryVariables>(CrmCompanySelectDocument, options);
        }
export type CrmCompanySelectQueryHookResult = ReturnType<typeof useCrmCompanySelectQuery>;
export type CrmCompanySelectLazyQueryHookResult = ReturnType<typeof useCrmCompanySelectLazyQuery>;
export type CrmCompanySelectSuspenseQueryHookResult = ReturnType<typeof useCrmCompanySelectSuspenseQuery>;
export type CrmCompanySelectQueryResult = Apollo.QueryResult<CrmCompanySelectQuery, CrmCompanySelectQueryVariables>;